<button class="dialog-close-btn" type="button" (click)="ref.close()">
    <i class="pi pi-times"></i>
</button>
<div class="dialog-content">
    <span>{{ 'paymentConfirmation.selectedPlan' | transloco }}</span>
    <div class="input-container">
        <app-plan-view-price [planView]="currentPlan"></app-plan-view-price>
    </div>
    <span>{{ 'paymentConfirmation.paymentMethod' | transloco }}</span>
    <app-payment-method [currentMethodPayment]="currentMethodPayment" [openDirect]="true"></app-payment-method>
    <div class="button-container">
        <button type="button" class="btn-general-black" (click)="purchase()">{{ txtButton }}</button>
    </div>
</div>